import React from 'react';

const ThemeCustomizationPage = () => {
    return (
        <div>
            
        </div>
    );
}

export default ThemeCustomizationPage;
